export const PAI_ANIMATION_BG_TYPE = {
    PARTICLE_BG: 'particle'
}